module.exports = __webpack_public_path__ + "img/mountainsbig.8ee70327.png";